module.exports = __webpack_public_path__ + "static/media/gal0010.c1cb9a19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal00/gal0010.jpg
// module id = 390
// module chunks = 0